function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "radicalbit_glyph_svg__u",
  x1: -4996.22,
  y1: -1166.34,
  x2: -4993.21,
  y2: -1166.34,
  gradientTransform: "matrix(0 74.84 74.84 0 87504.41 373979.15)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1171c2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#2883ca"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#499dd5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#5daedc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#65b4df"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "radicalbit_glyph_svg__w",
  x1: -5083.14,
  y1: -1189.01,
  x2: -5080.13,
  y2: -1189.01,
  gradientTransform: "matrix(-76.07 0 0 76.07 -386424.54 90552.21)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8f9192"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#888a8b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#777a7a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.94,
  stopColor: "#5b5e5e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#565959"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "radicalbit_glyph_svg__y",
  x1: -4959.14,
  y1: -1249.93,
  x2: -4956.14,
  y2: -1249.93,
  gradientTransform: "matrix(73.23 0 0 -73.23 363156.33 -91356.54)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f1f1f1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#bcbbba"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "radicalbit_glyph_svg__t"
}, /*#__PURE__*/React.createElement("path", {
  className: "radicalbit_glyph_svg__ad",
  d: "M141.46 58.79c7.3 1.63 14.55 3.99 21.65 7.11 59.46 26.1 86.5 95.46 60.4 154.92-12.26 27.92-34.05 48.69-59.89 60.17 66.72-8.19 118.37-65.06 118.37-133.99 0-17.85-3.46-34.89-9.76-50.49-17.79-22.34-43.71-38.29-74.15-42.95-6.02-.92-12.01-1.37-17.92-1.37-13.44 0-26.49 2.31-38.7 6.6"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "radicalbit_glyph_svg__v"
}, /*#__PURE__*/React.createElement("path", {
  className: "radicalbit_glyph_svg__ad",
  d: "M41.28 63.04c-10.81 26.8-11.82 57.62-.5 86.67 5.48 14.06 13.38 26.47 23.02 36.94a117.64 117.64 0 01.24-34.07c9.82-64.19 69.82-108.25 134.01-98.43 30.75 4.7 56.88 20.93 74.69 43.61C253.06 47.55 204.18 12 147 12c-42.82 0-80.99 19.94-105.72 51.04"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "radicalbit_glyph_svg__x"
}, /*#__PURE__*/React.createElement("path", {
  className: "radicalbit_glyph_svg__ad",
  d: "M12 147c0 74.56 60.44 135 135 135 6.05 0 12.01-.4 17.85-1.17 25.43-11.56 46.86-32.17 58.98-59.75 4.3-9.79 6.8-19.79 8.3-29.88-10.91 10.58-23.71 19.15-38.76 25.02-60.5 23.59-128.66-6.34-152.25-66.84-11.36-29.13-10.31-60.04.59-86.9C23.12 85.61 11.99 115 11.99 146.99"
})), /*#__PURE__*/React.createElement("style", null, ".radicalbit_glyph_svg__ad{fill:none}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "radicalbit_glyph_svg__k"
}, /*#__PURE__*/React.createElement("g", {
  id: "radicalbit_glyph_svg__r"
}, /*#__PURE__*/React.createElement("g", {
  id: "radicalbit_glyph_svg__s"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#radicalbit_glyph_svg__t)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-10 211.746 166.583)",
  fill: "url(#radicalbit_glyph_svg__u)",
  d: "M122.67 41.73H300.8v249.72H122.67z"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#radicalbit_glyph_svg__v)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-20 151.101 99.329)",
  fill: "url(#radicalbit_glyph_svg__w)",
  d: "M6.93-24.34h288.34v247.32H6.93z"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#radicalbit_glyph_svg__x)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#radicalbit_glyph_svg__y)",
  d: "M12 62.49h220.13V282H12z"
})))));

var SvgRadicalbitGlyph = function SvgRadicalbitGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 294 294"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,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";
export { SvgRadicalbitGlyph as ReactComponent };